module.exports = {
  "id": "151b561d-17de-425e-961f-01308394fbfb",
  "gtmIds": [],
  "hasInAppVersion": false,
  "group": "spotlio",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "languages": [
    "en-US"
  ],
  "website": "https://skiresorts.spotliowebsites.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}